import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';
import {
   AppointmentPractitioner,
   HealthcareProviderLocationIdentifier,
} from '@dreryk/egabinet-appointment-frontend-api';
import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { TimetableSlotSelectionEvent } from '@dreryk/react-calendar';
import { ModalConfirmExitConfig } from '@dreryk/react-components';
import { commonTranslationKeys, convertDateToLocalDate, convertDateToLocalTime } from '@dreryk/react-common';

import { getInitialEstimatedDuration } from '../../shared/form/fields/EstimatedDurationField.utils';
import { AppointmentFormInitializer } from '../../shared/form/AppointmentForm.types';

import { AppointmentCreateFormBean } from './AppointmentCreateForm';

export const modalConfirmExitConfig = (isDirty: boolean): ModalConfirmExitConfig => ({
   enabled: isDirty,
   cancelButtonLabel: commonTranslationKeys.no,
   confirmationButtonLabel: commonTranslationKeys.yes,
});

type AppointmentFormInitializerOptions = {
   selectedSlot: TimetableSlotSelectionEvent<AppointmentPractitioner>;
   healthcareLocationProviders: HealthcareProviderLocation[];
   healthcareProviderLocationIdentifierFromSchedule: HealthcareProviderLocationIdentifier | null;
   patient: PatientSimple | undefined;
};

export const appointmentCreateFormInitializer = (
   options: AppointmentFormInitializerOptions
): AppointmentFormInitializer => (): AppointmentCreateFormBean => {
   const {
      healthcareProviderLocationIdentifierFromSchedule,
      healthcareLocationProviders,
      patient,
      selectedSlot,
   } = options;

   const getHealthcareProviderLocationFromSchedule = (): HealthcareProviderLocation | null => {
      return (
         healthcareLocationProviders.find(
            (location) =>
               location.locationIdentifier.locationId ===
                  healthcareProviderLocationIdentifierFromSchedule?.locationId &&
               location.locationIdentifier.type === healthcareProviderLocationIdentifierFromSchedule.type
         ) ?? null
      );
   };

   const getHealthcareProviderLocationIfSingle = (): HealthcareProviderLocation | null => {
      if (healthcareLocationProviders.length === 1) {
         return healthcareLocationProviders[0];
      }

      return null;
   };

   const startTime = convertDateToLocalTime(selectedSlot.start);
   const endTime = convertDateToLocalTime(selectedSlot.end);
   const date = convertDateToLocalDate(selectedSlot.start);

   return {
      healthcareProviderLocation:
         getHealthcareProviderLocationFromSchedule() ?? getHealthcareProviderLocationIfSingle(),
      practitioner: selectedSlot.resource,
      startTime: startTime,
      endTime: endTime,
      date: date,
      estimatedDuration: getInitialEstimatedDuration(startTime, endTime, date),
      overlappingStrategy: 'SKIP_OVERLAPPING_DATES',
      dateConfirmedWithPatient: true,
      patient: patient ?? null,
      note: null,
      recurrence: false,
      receptionService: {
         selector: [],
         value: [],
      },
   };
};
